import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BackChevronIconSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import SupportIconSvg from '../../../assets/icons/icon-my-page-support.svg?react';
import { BaseButton, rubikTypographyStyles } from '../../../shared/ui';

type MyPageProfileHeaderProps = {
  onBack: () => void;
};

const BackButton = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  place-items: center;
`;

const BackIcon = styled(BackChevronIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(20)};
  color: ${({ theme }) => theme.colors.text.primary};

  & path {
    stroke: currentColor;
  }
`;

const Title = styled.h1`
  ${rubikTypographyStyles};
  min-width: 0;
  margin: 0;
  white-space: pre-line;
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

const HelpBadge = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(40)};
  height: ${({ theme }) => theme.scale.px(40)};
  display: grid;
  place-items: center;
`;

const HelpIcon = styled(SupportIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: 100%;
  height: 100%;
`;

const Header = styled.header.attrs({
  'data-ui': 'my-page-profile-header',
})`
  min-height: ${({ theme }) => theme.scale.px(56)};
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  column-gap: ${({ theme }) => theme.scale.px(15)};

  & > ${BackButton} {
    margin-top: ${({ theme }) => theme.scale.px(7)};
  }
`;

export function MyPageProfileHeader({ onBack }: MyPageProfileHeaderProps) {
  const { t } = useTranslation();

  return (
    <Header>
      <BackButton
        type="button"
        aria-label={t('myPage.backAria')}
        onClick={onBack}
      >
        <BackIcon />
      </BackButton>

      <Title>{t('myPage.title')}</Title>

      <HelpBadge
        type="button"
        aria-label={t('myPage.helpAria')}
        onClick={() => undefined}
      >
        <HelpIcon />
      </HelpBadge>
    </Header>
  );
}
